
export const yearGroups = [
    {name: "Year 1", year: 1},
    {name: "Year 2", year: 2},
    {name: "Year 3", year: 3},
    {name: "Year 4", year: 4},
    {name: "Year 5", year: 5},
    {name: "Year 6", year: 6},
    {name: "Year 7", year: 7},
    {name: "Year 8", year: 8},
    {name: "Year 9", year: 9},
    {name: "Year 10", year: 10},
    {name: "Year 11", year: 11},
    {name: "Year 12", year: 12},
    {name: "Year 13", year: 13}
];

export const typesOfIntervention = [
    {name: "Specialist", type: 'specialist'},
    {name: "Targeted", type: 'targeted'},
    {name: "Class Intervention", type: 'class_intervention'},
    {name: "No Intervention", type: 'no_intervention'}
];

export const attendanceIndicators = [
    {name: "Normal", status: 'normal'},
    {name: "Low", status: 'low'}
];

export const studentStatuses = [
    {name: "Inactive - Not Started", status: 'inactive_not_started'},
    {name: "Inactive - Intervention Completed", status: 'inactive_finished'},
    {name: "Inactive - Intervention Not Completed", status: 'inactive_not_completed_left'},
    {name: "Active - In School", status: 'active_in_school'},
    {name: "Active - Off Site", status: 'active_off_site'},
    {name: "Active - Home Educated", status: 'active_home_educated'}
];

export const userRoles = [
    {name: "Super Admin", role: 'super_admin'},
    {name: "SLT Admin", role: 'slt_member'},
    {name: "School Admin", role: 'school_admin'},
    {name: "Tutor Group Lead", role: 'tutor'},
    {name: "Supply TA", role: "supply_ta"},
];

export const selectableSubjects = [
    {name: "Maths - All Areas", subject: 'maths_all_areas'},
    {name: "Maths - Number Areas Only", subject: 'maths_main_areas'},
];

export const mainAreasOfMaths = [
    'number', 'operations', 'fractions-decimals-percentages'
];

export const documentCategories = [
    {name: "Report", type: 'report'},
    {name: "Assessment", type: 'assessment'},
    {name: "Other", type: 'other'}
];

export const sortByOptions = [
    {name: "Name", value: 'name'},
    {name: "Date", value: 'date'},
    {name: "Type", value: 'type'},
    {name: "Status", value: 'status'},
    {name: "Year Group", value: 'year_group'},
    {name: "Tutor Group", value: 'tutor_group'}
];

export const attendanceScores = [
    { id: "1-excellent", name: "1 - Excellent" },
    { id: "2-good", name: "2 - Good" },
    { id: "3-average", name: "3 - Average" },
    { id: "4-poor", name: "4 - Poor" }
];

export const effortScores = [
    { id: "1-excellent", name: "1 - Excellent" },
    { id: "2-good", name: "2 - Good" },
    { id: "3-average", name: "3 - Average" },
    { id: "4-poor", name: "4 - Poor" }
];

export const achievmentScores = [
    { id: "wt", name: "WT - Working towards expected" },
    { id: "e", name: "E - Expected" },
]

export const defaultPageLimit = 50;

// 10MB default max file size for uploads
export const maxFileSize = 10 * 1024 * 1024; 
